export default __webpack_public_path__ + "static/media/9_1_0.3137d3a0.png";